import update from 'immutability-helper';

import seatStateApi from '../lib/api/seatState';

// ------------------------------------
// Constants
// ------------------------------------

export const RECEIVE_SEATSTATE = 'SEATSTATE/LOAD_SEATSTATE_SUCCESS';

export function receiveSeatState(seatState) {
	return {
		type: RECEIVE_SEATSTATE,
		seatState,
	};
}

export function fetchSeatState() {
	return async (dispatch, getState) => {
		const seatState = await seatStateApi
			.getSeatState(
				getState().merchant.merchantId,
				getState().merchant.themeName,
				getState().event.selected);
		dispatch(receiveSeatState(seatState));
	};
}

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
	[RECEIVE_SEATSTATE]: (state, action) => update(state,
		{ $set: action.seatState },
	),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {};

export default function reducerFunction(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
